import jwt from 'jsonwebtoken';

export default function checkTokenValidity(token){
    const now = new Date();
    var decoded = jwt.decode(token, {complete: true});
    var valid = new Date(decoded.payload.exp*1000) > now
    console.log(now)
    console.log(decoded)
    console.log(valid)
    return valid
}